module.exports = __webpack_public_path__ + "img/upload_img.fc996629.png";